import * as tslib_1 from "tslib";
import { PlaceResultLoader } from './place-result-loader';
/**
 * Wrapper for Google Places API search methods that return paginated result sets. The wrapper exposes promise-based
 * access to the current, previous, and next pages.
 */
var PlaceResultWrapper = /** @class */ (function () {
    function PlaceResultWrapper(_retrieve, _handler, _loader, _prev) {
        this._retrieve = _retrieve;
        this._handler = _handler;
        this._loader = _loader;
        this._prev = _prev;
        if (!this._loader) {
            this._loader = new PlaceResultLoader(this._retrieve, this._handler);
        }
    }
    /**
     * Creates an instance of PlaceResultWrapper, given a method that implements the actual retrieval.
     * @param retrieve {(callback: PlaceResultCallback) => void} Method that implements the actual retrieval of search
     *  results. This method should accept a callback instance, and then call the proper Google Places API method for
     *  retrieving the results. The supplied callback should be passed to the underling Google Places API method.
     * @param [handler] {(results: PlaceResult[]) => PlaceResult[]} Optional handler method for performing post-processing
     *  of the results.
     * @returns {Promise<PlaceResultWrapper>} Promise that resolves to an instance of PlaceResultWrapper.
     */
    PlaceResultWrapper.wrap = function (retrieve, handler) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var wrapper;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        wrapper = new PlaceResultWrapper(retrieve, handler);
                        return [4 /*yield*/, wrapper._getResults()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, wrapper];
                }
            });
        });
    };
    PlaceResultWrapper.prototype._getResults = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._loader.getResults()];
                    case 1:
                        result = _a.sent();
                        this.places = result.places;
                        this.pagination = result.pagination;
                        return [2 /*return*/, this];
                }
            });
        });
    };
    Object.defineProperty(PlaceResultWrapper.prototype, "hasPrevPage", {
        /**
         * Returns true if there is a previous page
         */
        get: function () {
            return !!this._prev;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the PlaceResultWrapper corresponding to the previous page (if available).
     */
    PlaceResultWrapper.prototype.getPrevPage = function () {
        return this._prev;
    };
    Object.defineProperty(PlaceResultWrapper.prototype, "hasNextPage", {
        /**
         * Returns true if there is a next page
         */
        get: function () {
            return this.pagination && this.pagination.hasNextPage;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that resolves to the PlaceResultWrapper corresponding to the next page of results.
     */
    PlaceResultWrapper.prototype.getNextPage = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var page, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.hasNextPage) {
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, this._loader.loadPage(this.pagination)];
                    case 1:
                        page = _a.sent();
                        result = new PlaceResultWrapper(this._retrieve, this._handler, this._loader, this);
                        result.places = page.places;
                        result.pagination = page.pagination;
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return PlaceResultWrapper;
}());
export { PlaceResultWrapper };
